import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class Dashboard2Service {

    showLoaderHttpOptions = { headers: { 'hideLoader': 'true' } };

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    getCounts() {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/info');
    }

    getFormSubmissionData(tag) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/info/' + tag);
    }

    getInspections(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/inspections?filter=' + filter);
    }
    getAllInspections(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/totalInspections?filter=' + filter);
    }

    getInspectionsByUser(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/inspections/topUsers?filter=' + filter);
    }

    getHazards(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/hazards?filter=' + filter);
    }

    getHazardsByType(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/hazards/type?filter=' + filter);
    }
    getHazardsByTypeTrends(filter) {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboardreports/hazards/hazardTrend?filter=' + filter);
    }


    getRecentInspections() {
        // let header = this._capEngineService.getHeaders('dashboard');
        return this._http.get(environment.serverUrl + '/dashboard/inspections/recent');
    }

    getAllInspectionsByStatus() {
        return this._http.get(environment.serverUrl + '/dashboardreports/inspectionsByStatus')
    }

    getInspectionStatsExcel(data) {
        return this._http.post(environment.serverUrl + '/dashboardreports/inspectionStatsExcel', data, { observe: 'response', responseType: 'blob' })
    }

    getNewInspectionReportExcel(data) {
        return this._http.post(environment.serverUrl + '/dashboardreports/inspectionReport', data, { observe: 'response', responseType: 'blob' })
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard2/dashboard.service.ts